import type { RouteObject } from 'react-router';

import * as searchEventsHorizonRouteExports from '#/modules/search/events/page/SearchEvents.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchEventsRoutePaths } from './searchEvents.route-paths';

export const searchEventsRouteObjects = searchEventsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchEventsHorizonRouteExports),
})) satisfies RouteObject[];
